import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues } from './filters';

export const exportColumns = (t) => {
  return [
    { fieldName: 'id', fieldTitle: t('ID'), fieldType: 'TEXT' },
    { fieldName: 'originatedFrom', fieldTitle: t('Προέλευση'), fieldType: 'TEXT' },
    { fieldName: 'from', fieldTitle: t('Αποστολέας'), fieldType: 'TEXT' },
    { fieldName: 'to', fieldTitle: t('Παραλήπτης'), fieldType: 'TEXT' },
    { fieldName: 'cc', fieldTitle: t('CC'), fieldType: 'TEXT' },
    { fieldName: 'subject', fieldTitle: t('Θέμα'), fieldType: 'TEXT' },
    { fieldName: 'text', fieldTitle: t('Περιεχόμενο (text)'), fieldType: 'TEXT' },
    { fieldName: 'html', fieldTitle: t('Περιεχόμενο (html)'), fieldType: 'TEXT' },
    { fieldName: 'composedDate', fieldTitle: t('Ημερομηνία Σύνταξης'), fieldType: 'DATE' },
    { fieldName: 'sendDate', fieldTitle: t('Ημερομηνία Αποστολής'), fieldType: 'DATE' },
    { fieldName: 'failedDate', fieldTitle: t('Ημερομηνία Αποτυχίας'), fieldType: 'DATE' },
    { fieldName: 'failedReason', fieldTitle: t('Λόγος Αποτυχίας'), fieldType: 'TEXT' },
    { fieldName: 'failedDetails', fieldTitle: t('Λεπτομέρειες Αποτυχίας'), fieldType: 'TEXT' },
  ];
};

// export function useGetQuery(): any {
//   const [get, { loading }] = useLazyQuery(gqlGetQuery, { onCompleted: transformData });

//   const [result, setResult] = useState<any>([get, { loading, data: undefined }]);

//   function transformData(data) {
//     const recs = data.getFormsDefinitions.data.map(values => {
//       return {
//         ...values,
//         solvingPeriod: periodQtyUnitToString(values.solvingPeriodQty, values.solvingPeriodUnit),
//         restoringPeriod: periodQtyUnitToString(values.restoringPeriodQty, values.restoringPeriodUnit),
//         pausingPeriod: periodQtyUnitToString(values.pausingPeriodQty, values.pausingPeriodUnit),
//         repeatingPeriod: periodQtyUnitToString(values.repeatingPeriodQty, values.repeatingPeriodUnit),
//       };
//     });

//     const trsData = { getFormsDefinitions: { data: recs, recordCount: data?.getFormsDefinitions?.recordCount } };
//     setResult([get, { loading, data: trsData }]);
//   }

//   return result;
// }

export async function handleExport(client, queryState: any, t): Promise<void> {
  function useGetQuery() {
    return useLazyQuery(gqlGetQuery);
    //return [null, { loading: null, data: null }];
  }
  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };
  await exportXlsModal({
    apolloClient: client,
    exportFileName: 'export MaterialTypes',
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}
